import React from 'react'
import T from 'prop-types'
import ReactSpeedometer from 'react-d3-speedometer'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SEGMENT_COLORS = [
  '#005027',
  '#00974c',
  '#00cd69',
  '#f98700',
  '#ff3a21',
  '#d51400',
  '#b00f00',
]

export default function AppealingIndex({ value }) {
  const { t } = useTranslation()

  return (
    <Stack direction="row">
      <Stack justifyContent="center">
        <Typography variant="body2" align="right">
          {t('carDetails.appealing')} <br /> {t('carDetails.index')}
        </Typography>
        <Typography align="right" color="primary">
          <strong>{value || '-'}</strong>
        </Typography>
      </Stack>
      <Box mr={2} />
      <Box
        sx={{
          transform: 'rotate(90deg) scale(0.5) translate(-175%, -25%)',
          width: 42,
          height: 77,
        }}
      >
        <ReactSpeedometer
          textColor={'black'}
          width={190}
          height={150}
          ringWidth={25}
          minValue={0.5}
          maxValue={7.5}
          segments={7}
          value={value || 0}
          // needleColor={!value ? 'transparent' : 'black'}
          needleColor="black"
          needleHeightRatio={0.5}
          customSegmentLabels={[1, 2, 3, 4, 5, 6, 7].map((i) => ({
            text: `${i}`,
            position: 'INSIDE',
            color: '#fff',
          }))}
          currentValueText={' '}
          needleTransition="easeElastic"
          needleTransitionDuration={2500}
          segmentColors={SEGMENT_COLORS}
        />
      </Box>
    </Stack>
  )
}

AppealingIndex.propTypes = {
  value: T.number,
}
